/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2020-06-03 11:53:17
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/api/money.js
 */

/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：资金管理相关接口
 */
import { get } from '@common/http'

/**
 * 获取数据
 * @param param
 * @returns {*}
 */
export const getOrder = param => get('/order', param)

/**
 * 账单统计 资金管理
 * @param param
 * @returns {*}
 */
export const getStatisticFund = param => get('/statistic/fund', param)

/**
 * 统计数字
 * @param param
 * @returns {*}
 */
export const getStatisticIncome = param => get('/statistic/income', param)

/**
 * 耗卡记录 CardTypeCode: 1 次卡 2 充值卡   根据分页查找TOrderBase,并携带会员信息
 * @param param
 * @returns {*}
 */
export const getOrderPageWithMemberInfo = param =>
  get('/order/page-with-member-info', param)

/**
 * 开卡明细
 * @param param
 *
 */
export const getOpenCardData = param => get('/statistic/open-card-data', param)

// 品项现金业绩趋势图
export const getProjectOrderAmount = (data, param) => get(`/statistic/projectOrderAmountTrendChart?${data}`, param)

// 品项耗卡业绩趋势图
export const getCostAmountTrendChart = (data, param) => get(`/statistic/costAmountTrendChart?${data}`, param)

// 支出管理趋势图
export const getDisburseAmount = (data, param) => get(`/statistic/disburseAmountTrendChart?${data}`, param)

// 总客数趋势图
export const getCountMerNum = (data, param) => get(`/statistic/countMerNUmTrendChart?${data}`, param)

// 开充卡现金趋势图
export const getOpenChangeCard = (data, param) => get(`/statistic/openChangeCardTrendChart?${data}`, param)

// 开充卡现金趋势图
export const getProjectAmount = (data, param) => get(`/statistic/projectAmountTrendChart?${data}`, param)

// 续充金额趋势图
export const getRehargeAmount = (data, param) => get(`/statistic/rechargeAmountTrendChart?${data}`, param)

// 充值、次卡、折扣卡趋势图
export const getOpenCardAmount = (data, param) => get(`/statistic/openCardAmountTrendChart?${data}`, param)

// 本金耗卡业绩趋势图
export const getCostInit = (data, param) => get(`/statistic/costInitTrendChart?${data}`, param)

// 次卡耗卡业绩&&有限次卡耗卡业绩趋势图
export const getBrokerageAmount = (data, param) => get(`/statistic/brokerageAmountTrendChart?${data}`, param)

// 门店业绩总数据
export const getTenantTotal = (param) => get(`/statistic/tenantTotal`, param)



// WEBPACK FOOTER //
// ./src/api/money.js